
import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import {
    toastError,
    toastSuccess,
    powerGuidlineAmountActionId,
    formatAmount,
} from "../../../../../utils/constants";
import {
    getHotelDetails_action,
    getHotelEnquiryDetails_action,
    insertExhHotelAccommodationLog_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/hotelEnquiry_action/hotelEnquiry_action";
import Modal from "react-modal";
import { data, event } from "jquery";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import moment from "moment";
import { fill_action } from "../../../../../actions/fillCombo_action";
import VendorDrawer from "../../../../../common_components/vendor_module_drawer";
import VendorDetails from "../../vendorDetails";
import $ from 'jquery'
import VisitorTopMenu from "../../../../../common_components/visitor_module_topmenu";
import VisitorDrawer from "../../../../../common_components/visitor_module_drawer";
import VisitorHeader2 from "../../../../../common_components/visitor_module_header2";
//
class HotelEnquiry extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            DeadlineDate: "",
            DeadlineDateString: "",
            currentDate: moment().format("DD-MM-YYYY"),
            Is_View: false,
            StatusID: "",
            RoleID: sessionStorage.getItem("RoleIDSS"),
            HotelEnquiryDetails: {},
            isOpen: false,
            IsHotelBookingFull: false,
        };
    }

    componentDidMount() {
        this.setState({
            DeadlineDate:
                this.props.location.state != null &&
                    this.props.location.state != "" &&
                    this.props.location.state.Deadline != ""
                    ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
                    : "",
            StatusID:
                this.props.location.state != null &&
                    this.props.location.state != "" &&
                    this.props.location.state.StatusID != ""
                    ? this.props.location.state.StatusID
                    : "",
            is_View:
                this.props.location.state != null &&
                    this.props.location.state != "" &&
                    this.props.location.state.is_View != null
                    ? this.props.location.state.is_View
                    : sessionStorage.getItem("RoleIDSS") != 1,
        });

        this.getHotelEnquiryDetails()
        this.loadscript()
    }

    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }

    getHotelEnquiryDetails() {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .getHotelEnquiryDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        isLoading: false,
                        HotelEnquiryDetails: data.data[0][0],
                        IsHotelBookingFull: data.data[1][0]['IsHotelBookingFull'] || false,
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    insertExhHotelAccommodationLog() {
        const { HotelEnquiryDetails } = this.state
        this.setState({ isLoading: true })
        this.props
            .insertExhHotelAccommodationLog_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, isOpen: false })
                    window.open(`${HotelEnquiryDetails?.Link}`, "_blank")
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    onHotelFormClick() {
        this.props.navigate("/hotelEnquiryForm", {
            state: { from: "dashboard", exhID: sessionStorage.getItem('ExhRegistrationIDSS') },
        });
    }

    onBookingFormClick() {
        this.props.navigate("/bookingForm", {
            state: { from: "dashboard", exhID: sessionStorage.getItem('ExhRegistrationIDSS') },
        });
    }


    render() {
        const { isLoading, DeadlineDate, RoleID, currentDate, HotelEnquiryDetails, isOpen, IsHotelBookingFull } = this.state;
        const isDeadlinePassed =
            DeadlineDate &&
            moment(DeadlineDate, "DD-MM-YYYY").isValid() &&
            moment(currentDate, "DD-MM-YYYY").isAfter(
                moment(DeadlineDate, "DD-MM-YYYY")
            );
        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <ToastContainer />
                <>
                    {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
                        <ExhibitorHeader />
                    ) : (
                        <VisitorHeader2 />
                    )}
                    {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
                        <ExhibitorDrawer />
                    ) :
                        <VisitorDrawer />
                    }
                </>
                <div
                    className={"with-dr-container"}
                    style={{ marginTop: RoleID == 1 ? "0px" : "20px" }}
                >
                    <div className="main-container">
                        <div className="row">
                            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                                1 ? (
                                <ExhibitorTopMenu />
                            ) : <VisitorTopMenu />}
                        </div>
                        <div className="p-2">
                            <div className="row m-0">
                                <div className={`card rounded-1 border-0 ${RoleID == 1 ? "mt-7" : ''} p-0`}>
                                    <div class="card-header d-flex">
                                        <h3 class="card-title">Travel & Hospitality</h3>
                                    </div>
                                    <div class="card-body p-1 m-2">

                                        <div className="row" id="vendorList">
                                            {!IsHotelBookingFull ?
                                                <div className="col-md-4">
                                                    <input
                                                        type="radio"
                                                        name="vendor"
                                                        className="vendor-radio"
                                                    />

                                                    <div className="hv-card">
                                                        <div className="hv-card-header">
                                                            Enquiry for Hotel at Venue
                                                        </div>
                                                        <div className="hv-card-body" >
                                                            <span className="p-2 text-center">To submit the enquiry for hotel at venue, kindly click on the "Enquire Now" button below</span>
                                                        </div>
                                                        <div className="d-flex justify-content-center">
                                                            <div className="hv-info text-center pb-3">
                                                                <button className="btn btn-aqua hv-btn mt-2"
                                                                    onClick={(e) => this.onHotelFormClick(e)}
                                                                >
                                                                    Enquire Now
                                                                </button>
                                                            </div>
                                                            <div className="hv-info text-center pb-3 mx-2">
                                                                <button className="btn btn-aqua hv-btn mt-2"
                                                                    onClick={(e) => this.onBookingFormClick(e)}
                                                                >
                                                                    Booking Form
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> : ''
                                            }
                                            <div className="col-md-4">
                                                <input
                                                    type="radio"
                                                    name="vendor"
                                                    className="vendor-radio"
                                                />
                                                <div className="hv-card">

                                                    <div className="hv-card-header">
                                                        Other Hotel Near Venue & Facilities
                                                    </div>

                                                    <div className="hv-card-body">

                                                        <div className="hv-info">

                                                            <p>
                                                                <i className="fa fa-building"></i>
                                                                <span>{HotelEnquiryDetails?.VendorName || '-'}</span>
                                                            </p>

                                                            <p>
                                                                <i className="fa fa-address-book"></i>
                                                                <span>{HotelEnquiryDetails?.Address || '-'}</span>
                                                            </p>

                                                            <p>
                                                                <i className="fa fa-user"></i>
                                                                <span>{HotelEnquiryDetails?.CoordinatorName || '-'}</span>
                                                            </p>

                                                            <p>
                                                                <i className="fa fa-phone"></i>
                                                                <span>{HotelEnquiryDetails?.Mobile || '-'}</span>
                                                            </p>

                                                            <p>
                                                                <i className="fa fa-envelope"></i>
                                                                <span>{HotelEnquiryDetails?.Email || '-'}</span>
                                                            </p>

                                                        </div>

                                                        <button className="btn btn-aqua hv-btn mt-2"
                                                            onClick={() => this.setState({ isOpen: true })}
                                                        >
                                                            Enquire Now
                                                        </button>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-start m-2">
                                        <button
                                            type="button"
                                            className="btn rounded-1 mt-3 mb-3 btn-gray"
                                            onClick={() => window.history.back()}
                                        >
                                            Back
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="row m-0">
                                {isDeadlinePassed && (
                                    <span className="text-danger">
                                        THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                                    </span>
                                )}
                            </div> */}
                        </div>
                    </div>
                </div>

                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header text-white p-2">
                                <h6 className="modal-title fw-normal">
                                    Disclaimer
                                </h6>
                                <button
                                    type="button "
                                    class="btn-close btn-close-white"
                                    data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen: false })}
                                >
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div className="col-xl-12 mb-1">
                                        <p>{HotelEnquiryDetails?.Disclaimer}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button
                                    className={`btn btn-aqua mx-2`}
                                    onClick={() => this.insertExhHotelAccommodationLog()}
                                >
                                    Ok
                                </button>
                                {/* <button
                                    type="button"
                                    class="btn btn-gray"
                                    data-dismiss="modal"
                                    style={{ marginLeft: "5px" }}
                                    onClick={() => this.setState({ isOpen: false })}
                                >
                                    Close
                                </button> */}
                            </div>
                        </div>
                    </div>
                </Modal>

            </>
        );
    }
}

export default withRouter(
    connect(null, {
        getHotelDetails_action,
        getHotelEnquiryDetails_action,
        insertExhHotelAccommodationLog_action,
        fill_action,
    })(HotelEnquiry)
);
